// *********************************
// CoolGames Builder JavaScript file
// *********************************
import { s_wood1_particle, s_wood2_particle, s_wood3_particle, s_ice1_particle, s_ice2_particle, s_ice3_particle, s_stone1_particle, s_stone2_particle, s_stone3_particle, initializeImages } from "../code/AssetDefinitions/ImageDefinitions";
import { p_wood_particle, p_ice_particle, p_stone_particle } from "../code/AssetDefinitions/JsonDefinitions";
import { s_smokePuff, s_tnt } from "../code/AssetDefinitions/SpineDefinitions";
import { SoundManager } from "./SoundManager";
initializeImages();
export var PhysicsSettings = {
    physicsScale: 0.1,
    physicsTimeStep: 1 / 45,
    physicsMaxSteps: 1,
    physicsSettleThreshold: 1,
    physicsSettleThreshold_AngularVelocity: 1,
    physicsSettleTimer: 60,
    gravity: 20,
    velocityTolerance: 1,
    angularDampeningForCircles: 3,
    angularDampeningForBoxes: 2.5,
    textureResolution: 20,
    extraTextureScale: 1.05,
    physicsObjectScaleFactor: 0.95,
    maximumIdleReplaySteps: 5,
    balloonAwakenRadius: 10,
    shouldDrawGroundBlocks: false,
    slingshotAllowBackwardsShot: false,
    slingshotMaxSwipeDistUI: 140,
    slingshotDraggingRadiusUI: 150,
    slingshotCancelRadiusUI: 50,
    slingshotMaxSwipe: 5,
    slingshotHeightOffset: 2,
    // standardSettings
    slingshotMaxForce: 52.0,
    slingshotTrailMaxLength: 40,
    slingshotMightyScopeLength: 200,
    slingshotTrailSpeed: 7,
    slingshotTrailDistBetween: 4,
    slingshotDotMinScale: 0.6,
    slingshotDotMaxScale: 1,
    yellowBirdForce: 40,
    birdTrailDistBetweenDots: 2,
    blackBirdExplosionTime: 90,
    blueBirdSpread: 1,
    blueBirdAngleDeviation: 5 // difference of spread
};
export var PhysicsObjectType = {
    circle: 1,
    box: 2,
    rightTriangle: 3,
    isoscelesTriangle: 4
};
export var JointType = {
    distance: 1,
    weld: 2,
    revolute: 3,
    prismatic: 4,
    destroy: 5
};
export var PhysicsObjectMaterial = {
    "RedBird": {
        density: 13,
        restitution: 0.43,
        friction: 0.3,
        strength: -1,
        defence: -1,
        breakable: false,
        static: false
    },
    "BlueBird": {
        density: 7.5,
        restitution: 0.25,
        friction: 0.3,
        strength: -1,
        defence: -1,
        breakable: false,
        static: false
    },
    "YellowBird": {
        density: 12.5,
        restitution: 0.13,
        friction: 0.3,
        strength: -1,
        defence: -1,
        breakable: false,
        static: false
    },
    "BlackBird": {
        density: 15,
        restitution: 0.03,
        friction: 0.3,
        strength: -1,
        defence: -1,
        breakable: false,
        static: false
    },
    "BigBird": {
        density: 20,
        restitution: 0.03,
        friction: 0.3,
        strength: -1,
        defence: -1,
        breakable: false,
        static: false
    },
    "WhiteBird": {
        density: 7.5,
        restitution: 0.03,
        friction: 0.3,
        strength: -1,
        defence: -1,
        breakable: false,
        static: false
    },
    "Balloon": {
        density: 0.00001,
        restitution: 0.00001,
        friction: 2,
        strength: 1,
        defence: 2,
        breakable: true,
        static: true
    },
    "Metal": {
        density: 1,
        restitution: 0.05,
        friction: 0.3,
        strength: 2,
        defence: 2,
        breakable: true,
        static: true,
        smokePuff: {
            spine: s_smokePuff,
            name: "s_smoke_puff_generic"
        }
    },
    "Extras": {
        density: 0.5,
        restitution: 0.4,
        friction: 0.7,
        strength: 1,
        defence: 1,
        breakable: true,
        static: false,
        particle: {
            particle: p_wood_particle,
            images: [s_wood1_particle, s_wood2_particle, s_wood3_particle]
        },
        smokePuff: {
            spine: s_smokePuff,
            name: "s_smoke_puff_generic"
        }
    },
    "MatildaEgg": {
        density: 1,
        restitution: 0,
        friction: 0.7,
        strength: 1,
        defence: 1,
        breakable: true,
        static: false,
        particle: {
            particle: p_wood_particle,
            images: [s_wood1_particle, s_wood2_particle, s_wood3_particle]
        },
        smokePuff: {
            spine: s_smokePuff,
            name: "s_smoke_puff_generic"
        }
    },
    "BigPig": {
        density: 4.5,
        restitution: 0.1,
        friction: 0.2,
        strength: 5,
        defence: 1,
        breakable: true,
        static: false,
        smokePuff: {
            spine: s_smokePuff,
            name: "s_smoke_puff_generic"
        },
        impact: {
            spine: s_tnt,
            name: "impact"
        }
    },
    "Pig": {
        density: 1.5,
        restitution: 0.1,
        friction: 0.2,
        strength: 2.5,
        defence: 1,
        breakable: true,
        static: false,
        smokePuff: {
            spine: s_smokePuff,
            name: "s_smoke_puff_generic"
        },
        impact: {
            spine: s_tnt,
            name: "impact"
        }
    },
    "SmallPig": {
        density: 1.5,
        restitution: 0.1,
        friction: 0.2,
        strength: 5,
        defence: 1,
        breakable: true,
        static: false,
        smokePuff: {
            spine: s_smokePuff,
            name: "s_smoke_puff_generic"
        },
        impact: {
            spine: s_tnt,
            name: "impact"
        }
    },
    "Ice": {
        density: 1,
        restitution: 0.2,
        friction: 3,
        strength: 5,
        defence: 1,
        breakable: true,
        static: false,
        particle: {
            particle: p_ice_particle,
            images: [s_ice1_particle, s_ice2_particle, s_ice3_particle]
        },
        smokePuff: {
            spine: s_smokePuff,
            name: "s_smoke_puff_ice_block"
        },
        sounds: SoundManager.MaterialCollection.ICE
    },
    "Wood": {
        density: 1.5,
        restitution: 0.2,
        friction: 3,
        strength: 10,
        defence: 1,
        breakable: true,
        static: false,
        particle: {
            particle: p_wood_particle,
            images: [s_wood1_particle, s_wood2_particle, s_wood3_particle]
        },
        smokePuff: {
            spine: s_smokePuff,
            name: "s_smoke_puff_wood"
        },
        sounds: SoundManager.MaterialCollection.WOOD
    },
    "Stone": {
        density: 2,
        restitution: 0.2,
        friction: 0.5,
        strength: 10,
        defence: 15,
        breakable: true,
        static: false,
        particle: {
            particle: p_stone_particle,
            images: [s_stone1_particle, s_stone2_particle, s_stone3_particle]
        },
        smokePuff: {
            spine: s_smokePuff,
            name: "s_smoke_puff_stone"
        },
        sounds: SoundManager.MaterialCollection.STONE
    },
    "Static": {
        density: 1,
        restitution: 0,
        friction: 0.8,
        strength: -1,
        defence: -1,
        breakable: false,
        static: true
    }
};
export var DamageFactors = {
    RedBirdDamageFactors: {
        damageMultiplier: {
            "Ice": 1,
            "Wood": 1,
            "Stone": 1,
            "Pig": 2,
            "BigPig": 2,
            "SmallPig": 2,
            "Balloon": 60
        },
        velocityMultiplier: {
            "Ice": 1,
            "Wood": 1,
            "Stone": 1,
            "Pig": 1,
            "BigPig": 1,
            "SmallPig": 1,
            "Balloon": 1
        }
    },
    BlueBirdDamageFactors: {
        damageMultiplier: {
            "Ice": 2.5,
            "Wood": 1,
            "Stone": 0.1,
            "Pig": 2,
            "BigPig": 2,
            "SmallPig": 2,
            "Balloon": 60
        },
        velocityMultiplier: {
            "Ice": 1,
            "Wood": 1,
            "Stone": 1,
            "Pig": 1,
            "BigPig": 1,
            "SmallPig": 1,
            "Balloon": 1
        }
    },
    YellowBirdDamageFactors: {
        damageMultiplier: {
            "Ice": 1,
            "Wood": 2.5,
            "Stone": 0.1,
            "Pig": 10,
            "BigPig": 2,
            "SmallPig": 2,
            "Balloon": 60
        },
        velocityMultiplier: {
            "Ice": 1,
            "Wood": 1,
            "Stone": 1,
            "Pig": 1,
            "BigPig": 1,
            "SmallPig": 1,
            "Balloon": 1
        }
    },
    BlackBirdDamageFactors: {
        damageMultiplier: {
            "Ice": 1,
            "Wood": 0.5,
            "Stone": 2,
            "Pig": 2,
            "BigPig": 2,
            "SmallPig": 2,
            "Balloon": 60
        },
        velocityMultiplier: {
            "Ice": 1,
            "Wood": 1,
            "Stone": 1,
            "Pig": 1,
            "BigPig": 1,
            "SmallPig": 1,
            "Balloon": 60
        }
    },
    BigBirdDamageFactors: {
        damageMultiplier: {
            "Ice": 1,
            "Wood": 1,
            "Stone": 1,
            "Pig": 2,
            "BigPig": 2,
            "SmallPig": 2,
            "Balloon": 1
        },
        velocityMultiplier: {
            "Ice": 1,
            "Wood": 1,
            "Stone": 1,
            "Pig": 1,
            "BigPig": 1,
            "SmallPig": 1,
            "Balloon": 1
        }
    },
    WhiteBirdDamageFactors: {
        damageMultiplier: {
            "Ice": 1,
            "Wood": 1,
            "Stone": 1,
            "Pig": 2,
            "BigPig": 2,
            "SmallPig": 2,
            "Balloon": 60
        },
        velocityMultiplier: {
            "Ice": 1,
            "Wood": 1,
            "Stone": 1,
            "Pig": 1,
            "BigPig": 1,
            "SmallPig": 1,
            "Balloon": 60
        }
    }
};
